import React from 'react';
export function NavigationEyebrow() {
  return <div className="bg-gray-100 border-b border-gray-200 py-2 px-4" data-id="element-104">
      <div className="max-w-6xl mx-auto" data-id="element-105">
        <p className="text-xs sm:text-sm text-gray-600 text-center leading-relaxed" data-id="element-106">
          Lynnwood, Washington Taekwondo & Martial Arts School Helping Kids,
          Teens, and Adults Build Confidence, Discipline, and Respect
        </p>
      </div>
    </div>;
}